import { a as _toConsumableArray } from './_rollupPluginBabelHelpers-fb970440.js';
import React, { useContext } from 'react';
import { a as ConfigContext } from './ConfigProvider-9522944e.js';
import { useResponsiveParams, Text, Modal, DataGridGroup } from 'quanta-ui';
import { P as Parse } from './CurrencyFormater-d288bc4f.js';

function ModalViewBreakupIpa(_ref) {
  var _breakupData$plan, _breakupData$plan2, _ipaQuote$tabDetails, _ipaQuote$tabDetails$, _breakupData$tenure, _breakupData$tenure2, _ipaQuote$tabDetails2, _ipaQuote$tabDetails3, _ipaQuote$tabDetails4, _ipaQuote$tabDetails5, _ipaQuote$tabDetails6, _ipaQuote$tabDetails7, _ipaQuote$tabDetails8, _IPACalculatePremium$, _IPACalculatePremium$2, _breakupData$loading, _breakupData$loading2, _IPACalculatePremium$3, _IPACalculatePremium$4, _breakupData$discount, _breakupData$discount2;

  var showViewBreakup = _ref.showViewBreakup,
      setShowViewBreakup = _ref.setShowViewBreakup,
      IPACalculatePremium = _ref.IPACalculatePremium,
      ipaQuote = _ref.ipaQuote,
      productName = _ref.productName,
      breakupData = _ref.breakupData;
  var repeatForMobile = 2;
  var repeatForDesktop = 3;
  var repeat = useResponsiveParams({
    for_mobile: repeatForMobile,
    for_desktop: repeatForDesktop
  });

  var _useContext = useContext(ConfigContext),
      branding = _useContext.branding;

  var display_data = [{
    grid_data: [{
      colSpan: repeat,
      text: /*#__PURE__*/React.createElement(Text, {
        type: "subheading",
        severity: "info"
      }, productName)
    }]
  }, {
    grid_data: [{
      label: 'Plan Name',
      text: breakupData !== null && breakupData !== void 0 && (_breakupData$plan = breakupData.plan) !== null && _breakupData$plan !== void 0 && _breakupData$plan.name ? "".concat(breakupData === null || breakupData === void 0 ? void 0 : (_breakupData$plan2 = breakupData.plan) === null || _breakupData$plan2 === void 0 ? void 0 : _breakupData$plan2.name) : ipaQuote === null || ipaQuote === void 0 ? void 0 : (_ipaQuote$tabDetails = ipaQuote.tabDetails) === null || _ipaQuote$tabDetails === void 0 ? void 0 : (_ipaQuote$tabDetails$ = _ipaQuote$tabDetails.planTabDetails) === null || _ipaQuote$tabDetails$ === void 0 ? void 0 : _ipaQuote$tabDetails$.selectedPlan
    }, {
      label: 'Tenure',
      text: breakupData !== null && breakupData !== void 0 && (_breakupData$tenure = breakupData.tenure) !== null && _breakupData$tenure !== void 0 && _breakupData$tenure.value ? "".concat(breakupData === null || breakupData === void 0 ? void 0 : (_breakupData$tenure2 = breakupData.tenure) === null || _breakupData$tenure2 === void 0 ? void 0 : _breakupData$tenure2.value) : ipaQuote === null || ipaQuote === void 0 ? void 0 : (_ipaQuote$tabDetails2 = ipaQuote.tabDetails) === null || _ipaQuote$tabDetails2 === void 0 ? void 0 : (_ipaQuote$tabDetails3 = _ipaQuote$tabDetails2.planTabDetails) === null || _ipaQuote$tabDetails3 === void 0 ? void 0 : _ipaQuote$tabDetails3.selectedTenure
    }]
  }, {
    grid_data: ipaQuote !== null && ipaQuote !== void 0 && (_ipaQuote$tabDetails4 = ipaQuote.tabDetails) !== null && _ipaQuote$tabDetails4 !== void 0 && (_ipaQuote$tabDetails5 = _ipaQuote$tabDetails4.planTabDetails) !== null && _ipaQuote$tabDetails5 !== void 0 && _ipaQuote$tabDetails5.selectedPlan && IPACalculatePremium.totalPremium || breakupData ? [{
      text: /*#__PURE__*/React.createElement(Text, {
        type: "normal"
      }, "Members"),
      severity: 'info',
      colSpan: repeat === repeatForMobile ? 1 : 2
    }, {
      text: /*#__PURE__*/React.createElement(Text, {
        type: "normal",
        className: "flex justify-end mr-4"
      }, "Premium (", branding === null || branding === void 0 ? void 0 : branding.currency, ")"),
      severity: 'info',
      colSpan: 1
    }, {
      text: breakupData !== null && breakupData !== void 0 && breakupData.memberType ? breakupData === null || breakupData === void 0 ? void 0 : breakupData.memberType : ipaQuote === null || ipaQuote === void 0 ? void 0 : (_ipaQuote$tabDetails6 = ipaQuote.tabDetails) === null || _ipaQuote$tabDetails6 === void 0 ? void 0 : (_ipaQuote$tabDetails7 = _ipaQuote$tabDetails6.planTabDetails) === null || _ipaQuote$tabDetails7 === void 0 ? void 0 : (_ipaQuote$tabDetails8 = _ipaQuote$tabDetails7.memberType) === null || _ipaQuote$tabDetails8 === void 0 ? void 0 : _ipaQuote$tabDetails8.value,
      colSpan: repeat === repeatForMobile ? 1 : 2,
      type: 'normal'
    }, {
      text: /*#__PURE__*/React.createElement(Text, {
        className: "flex justify-end mr-4"
      }, breakupData ? Parse(breakupData === null || breakupData === void 0 ? void 0 : breakupData.netPremium, false) : Parse(IPACalculatePremium.netPremium, false)),
      colSpan: 1,
      type: 'normal'
    }, {
      text: /*#__PURE__*/React.createElement(Text, {
        type: "normal"
      }, repeat === repeatForMobile ? 'Base Premium' : 'Total Base Premium'),
      severity: 'info',
      colSpan: repeat === repeatForMobile ? 1 : 2
    }, {
      text: /*#__PURE__*/React.createElement(Text, {
        className: "flex justify-end mr-4"
      }, breakupData ? Parse(breakupData === null || breakupData === void 0 ? void 0 : breakupData.netPremium, false) : Parse(IPACalculatePremium.netPremium, false)),
      colSpan: 1
    }] : [{
      text: /*#__PURE__*/React.createElement(Text, {
        type: "title"
      }, "Members"),
      colSpan: repeat === repeatForMobile ? 1 : 2,
      severity: 'info'
    }, {
      text: /*#__PURE__*/React.createElement(Text, {
        type: "title"
      }, "Premium"),
      colSpan: 1,
      severity: 'info'
    }]
  }, {
    grid_data: IPACalculatePremium && (IPACalculatePremium === null || IPACalculatePremium === void 0 ? void 0 : (_IPACalculatePremium$ = IPACalculatePremium.loading) === null || _IPACalculatePremium$ === void 0 ? void 0 : _IPACalculatePremium$.length) > 0 ? [{
      text: /*#__PURE__*/React.createElement(Text, {
        type: "normal"
      }, "Loading"),
      severity: 'info',
      colSpan: repeat === repeatForMobile ? 1 : 2
    }, {
      text: /*#__PURE__*/React.createElement(Text, {
        type: "normal",
        className: "flex justify-end mr-4"
      }, "Amount (", branding === null || branding === void 0 ? void 0 : branding.currency, ")"),
      severity: 'info',
      colSpan: 1
    }].concat(_toConsumableArray(IPACalculatePremium === null || IPACalculatePremium === void 0 ? void 0 : (_IPACalculatePremium$2 = IPACalculatePremium.loading) === null || _IPACalculatePremium$2 === void 0 ? void 0 : _IPACalculatePremium$2.flatMap(function (loading, idx) {
      return [{
        text: "".concat(loading === null || loading === void 0 ? void 0 : loading.name),
        colSpan: repeat === repeatForMobile ? 1 : 2,
        type: 'normal'
      }, {
        text: /*#__PURE__*/React.createElement(Text, {
          className: "flex justify-end mr-4"
        }, Parse(loading === null || loading === void 0 ? void 0 : loading.amount, false)),
        colSpan: 1,
        type: 'normal'
      }];
    }))) : breakupData && (breakupData === null || breakupData === void 0 ? void 0 : (_breakupData$loading = breakupData.loading) === null || _breakupData$loading === void 0 ? void 0 : _breakupData$loading.length) > 0 ? [{
      text: /*#__PURE__*/React.createElement(Text, {
        type: "normal"
      }, "Loading"),
      severity: 'info',
      colSpan: repeat === repeatForMobile ? 1 : 2
    }, {
      text: /*#__PURE__*/React.createElement(Text, {
        type: "normal",
        className: "flex justify-end mr-4"
      }, "Amount (", branding === null || branding === void 0 ? void 0 : branding.currency, ")"),
      severity: 'info',
      colSpan: 1
    }].concat(_toConsumableArray(breakupData === null || breakupData === void 0 ? void 0 : (_breakupData$loading2 = breakupData.loading) === null || _breakupData$loading2 === void 0 ? void 0 : _breakupData$loading2.flatMap(function (loading, idx) {
      return [{
        text: "".concat(loading === null || loading === void 0 ? void 0 : loading.name),
        colSpan: repeat === repeatForMobile ? 1 : 2,
        type: 'normal'
      }, {
        text: /*#__PURE__*/React.createElement(Text, {
          className: "flex justify-end mr-4"
        }, Parse(loading === null || loading === void 0 ? void 0 : loading.amount, false)),
        colSpan: 1,
        type: 'normal'
      }];
    }))) : [{
      text: /*#__PURE__*/React.createElement(Text, {
        type: "normal"
      }, "Loading"),
      severity: 'info',
      colSpan: repeat === repeatForMobile ? 1 : 2
    }, {
      text: /*#__PURE__*/React.createElement(Text, {
        type: "normal",
        className: "flex justify-end mr-4"
      }, Parse(0, false)),
      severity: 'info',
      colSpan: 1
    }]
  }, {
    grid_data: IPACalculatePremium && (IPACalculatePremium === null || IPACalculatePremium === void 0 ? void 0 : (_IPACalculatePremium$3 = IPACalculatePremium.discount) === null || _IPACalculatePremium$3 === void 0 ? void 0 : _IPACalculatePremium$3.length) > 0 ? [{
      text: /*#__PURE__*/React.createElement(Text, {
        type: "normal"
      }, "Discounts"),
      severity: 'info',
      colSpan: repeat === repeatForMobile ? 1 : 2
    }, {
      text: /*#__PURE__*/React.createElement(Text, {
        type: "normal",
        className: "flex justify-end mr-4"
      }, "Amount (", branding === null || branding === void 0 ? void 0 : branding.currency, ")"),
      severity: 'info',
      colSpan: 1
    }].concat(_toConsumableArray(IPACalculatePremium === null || IPACalculatePremium === void 0 ? void 0 : (_IPACalculatePremium$4 = IPACalculatePremium.discount) === null || _IPACalculatePremium$4 === void 0 ? void 0 : _IPACalculatePremium$4.flatMap(function (discount, idx) {
      return [{
        text: "".concat(discount === null || discount === void 0 ? void 0 : discount.name),
        colSpan: repeat === repeatForMobile ? 1 : 2,
        type: 'normal'
      }, {
        text: /*#__PURE__*/React.createElement(Text, {
          className: "flex justify-end mr-4"
        }, Parse(discount === null || discount === void 0 ? void 0 : discount.amount, false)),
        colSpan: 1,
        type: 'normal'
      }];
    }))) : breakupData && (breakupData === null || breakupData === void 0 ? void 0 : (_breakupData$discount = breakupData.discount) === null || _breakupData$discount === void 0 ? void 0 : _breakupData$discount.length) > 0 ? [{
      text: /*#__PURE__*/React.createElement(Text, {
        type: "normal"
      }, "Discounts"),
      severity: 'info',
      colSpan: repeat === repeatForMobile ? 1 : 2
    }, {
      text: /*#__PURE__*/React.createElement(Text, {
        type: "normal",
        className: "flex justify-end mr-4"
      }, "Amount (", branding === null || branding === void 0 ? void 0 : branding.currency, ")"),
      severity: 'info',
      colSpan: 1
    }].concat(_toConsumableArray(breakupData === null || breakupData === void 0 ? void 0 : (_breakupData$discount2 = breakupData.discount) === null || _breakupData$discount2 === void 0 ? void 0 : _breakupData$discount2.flatMap(function (discount, idx) {
      return [{
        text: "".concat(discount === null || discount === void 0 ? void 0 : discount.name),
        colSpan: repeat === repeatForMobile ? 1 : 2,
        type: 'normal'
      }, {
        text: /*#__PURE__*/React.createElement(Text, {
          className: "flex justify-end mr-4"
        }, Parse(discount === null || discount === void 0 ? void 0 : discount.amount, false)),
        colSpan: 1,
        type: 'normal'
      }];
    }))) : [{
      text: /*#__PURE__*/React.createElement(Text, {
        type: "normal"
      }, "Discount"),
      severity: 'info',
      colSpan: repeat === repeatForMobile ? 1 : 2
    }, {
      text: /*#__PURE__*/React.createElement(Text, {
        type: "normal",
        className: "flex justify-end mr-4"
      }, Parse(0, false)),
      severity: 'info',
      colSpan: 1
    }]
  }, {
    grid_data: [{
      text: /*#__PURE__*/React.createElement(Text, {
        type: "normal"
      }, "Net Premium"),
      severity: 'info',
      colSpan: repeat === repeatForMobile ? 1 : 2
    }, {
      text: /*#__PURE__*/React.createElement(Text, {
        type: "normal",
        className: "flex justify-end mr-4"
      }, breakupData ? Parse(breakupData === null || breakupData === void 0 ? void 0 : breakupData.netPremium, false) : Parse(IPACalculatePremium !== null && IPACalculatePremium !== void 0 && IPACalculatePremium.netPremium ? IPACalculatePremium === null || IPACalculatePremium === void 0 ? void 0 : IPACalculatePremium.netPremium : 0, false)),
      severity: 'info',
      colSpan: 1
    }, {
      text: /*#__PURE__*/React.createElement(Text, {
        type: "normal"
      }, "GST/Tax"),
      severity: 'info',
      colSpan: repeat === repeatForMobile ? 1 : 2
    }, {
      text: /*#__PURE__*/React.createElement(Text, {
        type: "normal",
        className: "flex justify-end mr-4"
      }, breakupData ? Parse(breakupData === null || breakupData === void 0 ? void 0 : breakupData.gst, false) : Parse(IPACalculatePremium === null || IPACalculatePremium === void 0 ? void 0 : IPACalculatePremium.gst, false)),
      severity: 'info',
      colSpan: 1
    }, {
      //   text: <Text type="normal">Stamp Duty</Text>,
      //   severity: 'info',
      colSpan: repeat === repeatForMobile ? 1 : 2
    }, {
      // text: (
      //   <Text type="normal" className="flex justify-end mr-4">
      //     {breakupData
      //       ? CurrencyFormater(breakupData?.stampDuty, false)
      //       : CurrencyFormater(
      //       IPACalculatePremium?.stampDuty,
      //       false,
      //     )}
      //   </Text>
      //),
      severity: 'info',
      colSpan: 1
    }, {
      text: /*#__PURE__*/React.createElement(Text, {
        type: "subheading"
      }, "Total Premium"),
      severity: 'info',
      colSpan: repeat === repeatForMobile ? 1 : 2
    }, {
      text: /*#__PURE__*/React.createElement(Text, {
        type: "subheading",
        className: "flex justify-end mr-4"
      }, breakupData ? Parse(breakupData === null || breakupData === void 0 ? void 0 : breakupData.totalPremium, false) : Parse(IPACalculatePremium !== null && IPACalculatePremium !== void 0 && IPACalculatePremium.totalPremium ? IPACalculatePremium === null || IPACalculatePremium === void 0 ? void 0 : IPACalculatePremium.totalPremium : 0, false)),
      severity: 'info',
      colSpan: 1
    }]
  }];
  return /*#__PURE__*/React.createElement("div", {
    className: "text-black font-normal"
  }, /*#__PURE__*/React.createElement(Modal, {
    display: showViewBreakup,
    size: repeat === repeatForMobile ? 'full' : 'small',
    className: repeat === repeatForMobile ? 'h-screen flex flex-col' : '',
    title: "Premium Breakup for Quote",
    onClose: function onClose(e) {
      return setShowViewBreakup(false);
    }
  }, /*#__PURE__*/React.createElement(DataGridGroup, {
    data: display_data,
    textType: "normal",
    severity: "none",
    repeat: repeat,
    spaceY: 4
  })));
}

export { ModalViewBreakupIpa as M };
